import React from 'react';
import { Row } from 'react-bootstrap';
import { FormCol, FormFilterCard, FieldInput, FieldSelectIsActive } from 'motion-components';
import { useTranslation } from 'react-i18next';
import { FieldSelectCollector, FieldSelectSeriesType } from 'shared-pages';
import { useRootStore } from 'store';

/* ----------------------- Διαχείριση Φίλτρων ------------------------------ */
export function buildWhereFromFilterValues(values): string {
  // Φτιάξε το where για το graphql
  let where = {};
  if (values) {
    if (values.searchText) {
      const searchText = '%' + values.searchText + '%';
      const likeObj = { $like: searchText };
      where = {
        ...where,
        $or: [{ name: likeObj }, { docPrefix: likeObj }],
      };
    }
    if (values.isActive !== undefined && values.isActive !== null && values.isActive !== '') {
      where = { ...where, isActive: values.isActive };
    }
    if (values.hasLastNumber !== undefined && values.hasLastNumber !== null && values.hasLastNumber !== '') {
      where = { ...where, hasLastNumber: values.hasLastNumber };
    }
    if (values.collectorId) where = { ...where, collectorId: values.collectorId };
    if (values.seriestypeId) where = { ...where, seriestypeId: values.seriestypeId };
  }
  return JSON.stringify(where);
}

/* ----------------------- Filter Form ------------------------------ */
export const Filters = ({ onChange, initialValues, disable = false, isGridInForm }) => {
  //
  const { appStore } = useRootStore();
  const { t } = useTranslation();
  function handleFiltersSubmit(values, { setSubmitting }) {
    if (disable) return;
    setTimeout(() => {
      setSubmitting(false);
      onChange(values);
    }, 400);
  }

  const filters = {
    searchText: initialValues?.searchText ?? '',
    isActive: initialValues?.isActive ?? null,
    collectorId: initialValues?.collectorId ?? undefined,
    seriestypeId: initialValues?.seriestypeId ?? undefined,
    hasLastNumber: initialValues?.hasLastNumber ?? undefined,
  };

  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
    >
      <Row>
        <FieldInput
          as={FormCol}
          name="searchText"
          label={t('Αναζήτηση ( Πρόθεμα, Περιγραφή Σειράς )')}
          type="search"
          disable={disable}
        />
        <FieldSelectSeriesType as={FormCol} />
        {!isGridInForm && appStore.isPlatformOwner && (
          <FieldSelectCollector as={FormCol} name="collectorId" label={t('Συλλέκτης')} />
        )}
        <FieldSelectIsActive label={t('Ενεργές Εγγραφές')} disable={disable} />
        <FieldSelectIsActive as={FormCol} name="hasLastNumber" label={t('Έχει Χρησιμοποιηθεί')} disable={disable} options={[{ value: true, label: t('Ναι') }, { value: false, label: t('Όχι') }]} />
      </Row>
    </FormFilterCard>
  );
};
